import { IconProps } from 'utils/global.types';

export const Create = (props?: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M5 10a1 1 0 0 1 1-1h3V6a1 1 0 0 1 2 0v3h3a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3H6a1 1 0 0 1-1-1Zm19-1v10c0 2.757-2.243 5-5 5H9c-2.446 0-4.479-1.768-4.908-4.092C1.768 19.479 0 17.446 0 15V5c0-2.757 2.243-5 5-5h10c2.446 0 4.479 1.768 4.908 4.092C22.232 4.521 24 6.554 24 9ZM5 18h10c1.654 0 3-1.346 3-3V5c0-1.654-1.346-3-3-3H5C3.346 2 2 3.346 2 5v10c0 1.654 1.346 3 3 3Zm17-9a2.996 2.996 0 0 0-2-2.816V15c0 2.757-2.243 5-5 5H6.184A2.996 2.996 0 0 0 9 22h10c1.654 0 3-1.346 3-3V9Z" />
  </svg>
);
